/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import CardC from "../../../components/CustomCard/CardC";
import Datatable from "../../../components/Datatable/Datatable";
import peticionBack from "../../../libs/peticiones/peticionBack";
import { Loader, toaster } from "rsuite";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { swalAction } from "../../../components/Modals/ModalConfirm";
import Form from "./Form";
import { Button } from "react-bootstrap";
import createURL from "../../../libs/peticiones/url";
import { useStore } from "../../../context/AppContext";
import { checkPermission } from "../../../libs/menuPermissions/permissions";
import { Distrito } from "../../../types/compl-archivos/Distrito";
import { Region } from "../../../types/compl-archivos/Region";

export default function Distritos() {
    const [loading, setLoading] = useState<boolean>(false);
    const [refresh, setRefresh] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const [selected, setSelected] = useState<Distrito | undefined>();
    const [regiones, setRegiones] = useState<Region[]>([]);
    const { state } = useStore();

    useEffect(() => {
        getRegiones();
    }, []);

    async function getRegiones() {
        const res = await peticionBack({}, "/regiones", "GET", false, toaster);
        if (res) setRegiones(res.data);
        setLoading(false);
    }

    async function getData(order: string, records: number, page: number, search: string) {
        const url = createURL("/distritos", [
            { name: "order", value: order },
            { name: "records", value: records },
            { name: "page", value: page },
            { name: "search", value: search },
            { name: "rows", value: "_id,name,region" },
            { name: "populate", value: "region" },
        ]);
        const res = await peticionBack({}, url, "GET", false, toaster);
        return res;
    }

    /* TABLA */
    const columns = [
        { data: "name" },
        { data: "region", render: (r: Region) => r?.name },
        {
            data: null,
            render: (row: Distrito) => (
                <div className="d-flex justify-content-evenly">
                    {checkPermission(state, "update") && <FontAwesomeIcon icon={faPencil} className="text-warning cursor-pointer" onClick={() => openToEdit(row)} />}
                    {checkPermission(state, "delete") && (
                        <FontAwesomeIcon icon={faTrashCan} className="text-danger cursor-pointer" onClick={() => swalAction(deleteRow, "Eliminar distrito", `¿Desea eliminar el distrito ${row.name}?`, "question", row._id, "Eliminar")} />
                    )}
                </div>
            ),
        },
    ];

    const columnDefs = [{ orderable: false, targets: [1] }];

    async function deleteRow(id: number) {
        setLoading(true);
        const res = await peticionBack({}, `/distritos/${id}`, "DELETE", true, toaster);
        if (res) setRefresh(true);
        setLoading(false);
    }

    function openToEdit(row: Distrito) {
        setSelected(row);
    }

    useEffect(() => {
        if (selected) setOpen(true);
    }, [selected]);

    useEffect(() => {
        if (!open) {
            if (selected) {
                setSelected(undefined);
            }
        }
    }, [open]);

    return (
        <CardC>
            <div className="d-flex flex-column flex-md-row justify-content-md-between mb-2">
                <h4 className="">Distritos {open && (selected ? "- Editar" : "- Agregar")}</h4>
                {!open && checkPermission(state, "create") && (
                    <Button onClick={() => setOpen(true)} className="my-1 my-md-0">
                        Agregar
                    </Button>
                )}
            </div>
            {open ? (
                <Form setOpen={setOpen} selected={selected} regiones={regiones} />
            ) : (
                checkPermission(state, "read") && <Datatable columns={columns} headers={["Nombre", "Región", "Acciones"]} columnDefs={columnDefs} petition={getData} control="back" stateRefresh={[refresh, setRefresh]} className="p-0" />
            )}
            {loading && <Loader backdrop vertical style={{ zIndex: 5 }} />}
        </CardC>
    );
}
